module.exports = __webpack_public_path__ + "static/media/G1.dad05a67.png";